export enum E_TRANS_KEYS {
  HomeTitle = 'HomeTitle'
}

export type TTranslationKeys = {
  [E_TRANS_KEYS.HomeTitle]: string;
};
